<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="items.length > 0">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div>
        Правопредшественник ({{prevItems.length}})
        </div>      
        <div>
          Правопреемник ({{nextItems.length}})
        </div>      
      </div>  
      </v-panel-title>
      <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show="!isLoading">
        <v-flex v-if="items.length===0">
          Данные не найдены.
        </v-flex>
        <div>
        Правопредшественник ({{prevItems.length}})
          <div v-show = "isLoaded">
            <template v-for="item in prevItems">
              <div>
                <div v-html="renderReference(item.value)">
                </div>
                <v-flex pl-2>
                  <div>ИНН <b><span v-html="renderInnHtml(item.value.inn)"></span></b>
                  </div>
                  <span v-html="renderDateSince(item)"></span>
                </v-flex>
              </div>
            </template>
          </div>
        </div>      
        <div>
          Правопреемник ({{nextItems.length}})
          <div v-show = "isLoaded">
            <template v-for="item in nextItems">
              <div>
                <div v-html="renderReference(item.value)">
                </div>
                <v-flex pl-2>
                  <div>ИНН <b><span v-html="renderInnHtml(item.value.inn)"></span></b>
                  </div>
                  <span v-html="renderDateSince(item)"></span>
                </v-flex>
              </div>
            </template>
          </div>
        </div>      
      </div>  
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-assignees-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderDateSince: 'renderDateSince'
      }),
      prevItems () {
        return this.items.filter(a => a.type === 'PREV')
      },
      nextItems () {
        return this.items.filter(a => a.type === 'NEXT')
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      sortItems (a, b) {
        const getRank = (kind) => ['PREV', 'NEXT'].indexOf(kind)

        var result = 0
        if (!result) {
          result = getRank(a.type) - getRank(b.type)
        }
        if (!result && !(b.value && a.value)) {
          result = (b.value != null) - (a.value != null)
        }
        if (!result && (b.value && a.value)) {
          result = formats.compareString(a.value.name, b.value.name)
        }
        return result
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о компаниях правоприемниках и правопредшественниках из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/assignees',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.items = data
            this.isLoading = false
            this.items.sort((a, b) => this.sortItems(a, b))
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// AssigneesPanel.vue?2c522246